import { sellerService } from 'api/services/SellerService';

/**
 * Resolves public display names for chat peers (personal name or corporate company name).
 */
export async function fetchPeerDisplayNames(peerIds: string[]): Promise<Record<string, string>> {
  const unique = Array.from(new Set(peerIds.filter(Boolean)));
  const nameMap: Record<string, string> = {};

  await Promise.all(
    unique.map(async (uid) => {
      try {
        const res = await sellerService.getProfile(uid);
        const name = res.data?.displayName?.trim();
        nameMap[uid] = name || 'Kullanıcı';
      } catch {
        nameMap[uid] = 'Kullanıcı';
      }
    }),
  );

  return nameMap;
}

export function peerDisplayNameFromMap(
  peerId: string | null | undefined,
  nameMap: Record<string, string>,
): string {
  if (!peerId) return 'Kullanıcı';
  return nameMap[peerId] ?? 'Kullanıcı';
}
